import { isAfter, isBefore, parseISO, subHours } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

import type { AuthorizationStatusEnum, IDeviceInfo, TMotionActivityType } from '../../../../types/tracking'
import { getMotionActivity } from '../../../../utils/tracking'
import { authorizationStatusInstructions } from '../constants'

export const getMotionActivityWithEmoji = (motionActivity: TMotionActivityType | null) => {
  return getMotionActivity(motionActivity)
}

export const actionRequiredMessage = (authorizationStatus: AuthorizationStatusEnum | undefined) => {
  const defaultMessage =
    'This device has not been authorized to use location services. Please call the driver and ask them to set the app and phone permissions to "Always".'

  const message = authorizationStatusInstructions[authorizationStatus as keyof typeof authorizationStatusInstructions]
  return message || defaultMessage
}

export const formatDate = (utcDateString: string): string => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const date = parseISO(utcDateString)
  return formatInTimeZone(date, userTimezone, "M/d 'at' h:mm a")
}

export const isMoreThanEightHoursAgo = (utcDateString: string | null): boolean => {
  if (!utcDateString) return false
  const eightHoursAgo = subHours(new Date(), 8)
  const date = parseISO(utcDateString)
  return isBefore(date, eightHoursAgo)
}

export const isNotMovingOnIPhone = (params: {
  device: IDeviceInfo | null
  motionActivity: TMotionActivityType | null
  utcDateString: string | null
}) => {
  const { motionActivity, utcDateString } = params

  if (!utcDateString) return false

  const isActivityStillOrMovingSlow =
    motionActivity === 'still' ||
    motionActivity === 'on_foot' ||
    motionActivity === 'walking' ||
    motionActivity === 'running'

  if (!isActivityStillOrMovingSlow) return false

  const date = parseISO(utcDateString)
  const oneHourAgo = subHours(new Date(), 1)
  const eightHoursAgo = subHours(new Date(), 8)

  return isBefore(date, oneHourAgo) && isAfter(date, eightHoursAgo)
}
